import { NgModule } from '@angular/core';
import { WorkCenterComponent } from './containers/work-center.component';
import { SharedModule } from '@bd/shared/shared.module';
import { EditWorkcenterDetailsComponent } from './containers/components/edit-workcenter-details/edit-workcenter-details.component';
import { ChangeWarehouseComponent } from './containers/components/change-warehouse/change-warehouse.component';

@NgModule({
  declarations: [WorkCenterComponent, EditWorkcenterDetailsComponent, ChangeWarehouseComponent],
  imports: [SharedModule]
})
export class WorkCenterModule {}
